import React from 'react'
import AccountButton from './AccountButton'

import './SidebarMenuBottom.scss'

interface SidebarMenuBottomProps {
  readonly currentAccountId: number
  readonly currentAccountName: string
  readonly currentAccountAvatarUrl?: string
  readonly accountPopupIsOpen: boolean
  toggleAccountPopup(): void
}

const SidebarMenuBottom: React.FC<SidebarMenuBottomProps> = props => {
  const {
    currentAccountId,
    currentAccountName,
    currentAccountAvatarUrl,
    accountPopupIsOpen
  } = props

  return (
    <div className="SidebarMenuBottom">
      <AccountButton
        currentAccountId={currentAccountId}
        currentAccountName={currentAccountName}
        currentAccountAvatarUrl={currentAccountAvatarUrl}
        toggleAccountPopup={props.toggleAccountPopup}
        accountPopupIsOpen={accountPopupIsOpen}
      />
    </div>
  )
}

export default SidebarMenuBottom
